import { useMediaQuery } from '@material-ui/core';

const useIsTabletBelow = () => useMediaQuery('(max-width:1024px)');

export default useIsTabletBelow;
